import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.height || "200px"};
  color: #888;
  font-size: 14px;
`;

/**
 * Empty state message component
 * @param {{ message: string, height?: string | number }} props
 */
export const EmptyMessage = ({ message, height = "200px" }) => {
  return <Container height={typeof height === "number" ? `${height}px` : height}>{message}</Container>;
};

export default EmptyMessage;
